import React from 'react';
import { Login as LoginComponent } from '@smorder/core';
import { NavigationLink } from '../../components';

import config from '../../../run-config';

const Login = (props) => {
  const forgotPassword = <NavigationLink to="/forgotPassword">Passwort vergessen?</NavigationLink>;

  return (
    <LoginComponent
      {...props}
      logo={config.loginLogo}
      mail={config.mail}
      telnr={config.telnr}
      copyrightBy={config.copyrightBy}
      forgotPassword={forgotPassword}
    />
  );
};

export default Login;
